/* @flow */

import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import {
  Select,
  // $FlowFixMe
} from '@bijie/react-bnb';
import EmptyTable from '../EmptyTable';
import { getLabel } from '../../utils/i18n';
import { fetchMarginDataSource } from '../../actions/actionsSet/margin';

const Wrapper = styled.div`
  .title {
    line-height: 15px;
    color: #848E9C;
    font-size: 12px;
    font-family: ${({ theme }) => theme.fontIBMRegular};
  }
  .table-title {
    margin: 30px 0 16px 0;
    line-height: 19px;
    color: #212833;
    font-size: 15px;
    font-weight: 500;
  }
  .symbol-select {
    width: 150px;
  }
  .bnc-table-header::-webkit-scrollbar-track {
    background: rgba(234, 236, 239, .3);
  }
  .bnc-table-body::-webkit-scrollbar-track {
    background: rgba(234, 236, 239, .2);
  }
  .bnc-table-body::-webkit-scrollbar {
    width: 7px;
  }
`;

const StyledSelect = styled(Select)`
  .bnc-select-dropdown-menu {
    max-height: 248px;
  }
`;

const getPriceIndexColumn = (i18n) => [
  {
    title: getLabel('exchange-margindata-time', i18n),
    dataIndex: 'timestamp',
    key: 'timestamp',
    width: '33%',
    render: timestamp => moment(+timestamp).format('YYYY-MM-DD HH:mm:ss'),
  },
  {
    title: getLabel('exchange-margindata-symbol', i18n),
    dataIndex: 'symbol',
    key: 'symbol',
    width: '33%',
  },
  {
    title: getLabel('exchange-margindata-indexvalue', i18n),
    dataIndex: 'price',
    align: 'left',
    key: 'price',
  },
];

type Props = {
  i18n: Object,
  coinList: Array<Object>,
}
type States = {
  curSymbol: string,
  loading: bool,
  dataSource: Array<Object>,
}

export default class PriceIndexHistory extends React.PureComponent<Props, States> {
  constructor(props: Props) {
    super(props);
    this.state = {
      loading: false,
      curSymbol: props.coinList?.[0]?.symbol,
      dataSource: [],
    };
  }

  componentDidMount() {
    this._fetchData(this.state.curSymbol);
  }

  _fetchData = async (pair: string = '') => {
    const query = {
      pair,
      limit: 200,
    };
    const { data } = await fetchMarginDataSource('price-index', query);
    this.setState({
      loading: false,
      dataSource: data,
    });
  }

  _handleCoinSelectChange = (curSymbol: string) => {
    this.setState({
      loading: true,
      curSymbol,
    });
    this._fetchData(curSymbol);
  }

  render() {
    const { i18n, coinList } = this.props;
    const { loading, curSymbol, dataSource } = this.state;

    return (
      <Wrapper>
        <div className="title">{getLabel('exchange-margindata-selectsymbol', i18n)}</div>
        <StyledSelect
          size="sm"
          value={curSymbol}
          className="symbol-select"
          defaultActiveFirstOption={false}
          onChange={this._handleCoinSelectChange}
        >
          {
            coinList.map(({ symbol }, idx) => (
              <Select.Option key={idx} value={symbol}>{symbol}</Select.Option>
            ))
          }
        </StyledSelect>
        <p className="table-title">{getLabel('exchange-margindata-indexvalue', i18n)}</p>
        <EmptyTable
          i18n={i18n}
          scroll={{ y: 424 }}
          data={dataSource}
          pagination={false}
          loading={loading}
          columns={getPriceIndexColumn(i18n)}
          rowKey={({ idx }) => idx}
        />
      </Wrapper>
    );
  }
}
